module.exports = __webpack_public_path__ + "img/aerospace-and-defence.7f4299c0.svg";